export enum NewsletterType {
  Email = 1,
  Sms = 2,
  Push = 3,

}
